import React from 'react';
import { WaSummaryItem } from 'src/api/wa/store/models/workplace/WaSummary';

const Row: React.FC<{ left: React.ReactNode; right: React.ReactNode; isHeader?: boolean }> = ({
  left,
  right,
  isHeader = false,
}) => {
  const textClass = isHeader ? 'font-bold' : '';

  return (
    <div
      className={`grid grid-cols-2 gap-4 border-t border-gray-400 px-2 py-1 text-sm ${textClass}`}
    >
      <div className="text-right">{left}</div>
      <div className="text-right">{right}</div>
    </div>
  );
};

interface ProgressSearchCellProps {
  headerLabel: string;
  headerValue: string | number;
  rows: WaSummaryItem[];
}

const ProgressSearchCell: React.FC<ProgressSearchCellProps> = ({
  headerLabel,
  headerValue,
  rows,
}) => {
  return (
    <div className="mb-4 w-full pb-2">
      <Row left={headerLabel} right={headerValue} isHeader />
      {(rows || []).map((row, idx) => (
        <Row key={idx} left={row.squadCode ?? ''} right={row.squadSummary ?? ''} />
      ))}
    </div>
  );
};

export default ProgressSearchCell;
